import React from 'react';
import { Button, Grid, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from '@material-ui/core';
import SubTitle from '../components/Text/SubTitle';
import Table from '../components/Table/Table';

// import swal from '@sweetalert/with-react';
// import Preparing from '../components/Preparing';

const styles = (theme) => ({
  body: {
    color: '#777',
    fontWeight: 600,
  },
  content: {
    color: '#555',
    fontSize: '1.2em',
    lineHeight: 1.6,
  },
  indentText: {
    paddingLeft: '1em',
  },
  redBold: {
    color: 'red',
    fontWeight: 'bold',
  },
  emailAddress: {
    color: '#3b63ca',
  },

  topSpacing: {
    paddingTop: theme.spacing(4),
  },

  styledTh: {
    '& th': {
      color: '#7d889a',
    },
    '& tr th:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  styledTd: {
    '& tr td:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  tdAlignCenter: {
    '& td': {
      textAlign: 'center',
    },
  },
  typosub: {
    fontWeight: 'bold',
    color: '#F1B77E',
  },

  orderedList: {
    '& li': { fontWeight: 500, fontSize: '1.2em', lineHeight: 1.7 },
  },
});

const TypoTitle = withStyles((theme) => ({
  root: {
    color: '#647186',
    fontSize: '1.3em',
    fontWeight: 'bold',
  },
}))(Typography);

const TypoSub = withStyles((theme) => ({
  root: {
    color: '#555',
    fontSize: '1.1em',
    fontWeight: 500,
  },
}))(Typography);

const FILE_FORMAT_DATA = {
  'Screen Ratio\n(Presentation File Format)': (
    <div>
      <p style={{ color: '#f00', fontWeight: 'bold', fontSize: '1.2em' }}>PowerPoint 4:3 size</p>
      <p>As for the aspect ratio of your presentation file (slides), a ratio of 4:3 is recommended.</p>
      <img src="/images/PRS2021/freepaper/presentation_01.png" style={{ width: '30%' }} alt="" />
      <img src="/images/PRS2021/freepaper/presentation_02.png" style={{ width: '80%' }} alt="" />
    </div>
  ),
  'Font & Image': (
    <div>
      Default font provided by MS Office
      <br />
      Images should be in JPG, GIF or BMP format.
    </div>
  ),
  'First Slide': (
    <div>
      The following must be included on the first slide of your file :<br />
      Abstract Title, Presenter’s Name and Co-author's Names, Affiliation and Country.
    </div>
  ),
};

const ONSITE_PRE_SUBMISSION_DATA = {
  'Deadline for File Submission': <p style={{ color: '#f00', fontWeight: 'bold' }}>August 13(Sat), 2022</p>,
  'How to Submit': (
    <div>
      Please send the VOD File to PRS KOREA 2022 Secretariat (
      <a href={'mailto:secretariat.kprs@innon.co.kr'}>secretariat.kprs@innon.co.kr</a>)
    </div>
  ),
  'File Name': (
    <div>
      <b>Your Session Name</b>
      <br />
      ex) Laser Name
    </div>
  ),
  'File Submission': <div>Please submit your presentation file(PPT file).</div>,
};

const HOW_TO_UPLOAD = {
  'How to Submit': (
    <div>
      Please send <b style={{ color: '#f00' }}>both recorded presentation file (mp4) and PPT file</b> to PRS KOREA 2022 Secretariat. (
      <a href={'mailto:secretariat.kprs@innon.co.kr'}>secretariat.kprs@innon.co.kr</a>)
    </div>
  ),
  'File Name': (
    <div>
      <b>Abstract No._Presenter Name</b>
    </div>
  ),
  'File Submission': <div>Please submit both recorded presentation (mp4) file.</div>,
};

const PRESENTATION_TIME = {
  Symposium: <div>Presentation 12~15min. / Q&A 12~15min after all presentation</div>,
  'Breast 1~2': <div>Presentation 7~8min. / Q&A 16~18min after all presentation</div>,
  'Bone Contouring 1~2': <div>Presentation 7min. / Q&A 6min real-time right after each presentation</div>,
  'Keynote Lecture \n Songbaek Lecture \n Invited Lecture(Sponsored by Hallym)': <div>Presentation 45~50min. / Q&A 10~15min.</div>,
  'Retirement Lecture': <div>Presentation 45~50min. / Q&A 10~15min.</div>,
  'Video Session': <div>Presentation 45~50min. / Q&A 10~15min.</div>,
  'Free Paper': <div>Presentation 5min. / Q&A 2min.</div>,
};

class PresentationOral extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowOnsiteSpeakersInfo: false,
      isShowPreRecordedSpeakersInfo: false,
    };
  }

  guideLinesDownload = (lang) => {
    if (lang === 'eng') {
      window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2021/Presentation+Recording+Guideline_ENG.pdf`, '_blank');
    } else {
      window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2021/Presentation+Recording+Guideline_KOR.pdf`, '_blank');
    }
  };

  renderTypeInfoTable() {
    return (
      <Table>
        <TableHead className={this.props.classes.styledTh}>
          <TableRow>
            <TableCell colSpan={2}>Category</TableCell>
            <TableCell>Presentation</TableCell>
            <TableCell>Q&A</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={`${this.props.classes.tdAlignCenter} ${this.props.classes.styledTd}`}>
          <TableRow>
            <TableCell rowSpan={3}>
              Overseas <br />
              Speaker
            </TableCell>
            <TableCell>Symposium</TableCell>
            <TableCell>Recording</TableCell>
            <TableCell>Online real-time</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Keynote Lecture <br />
              Songbaek Lecture <br />
              Invited Lecture(Sponsored by Hallym)
            </TableCell>
            <TableCell>Online real-time</TableCell>
            <TableCell>Online real-time</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Free Paper</TableCell>
            <TableCell>Recording</TableCell>
            <TableCell>Online real-time</TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan={4}>
              Korean <br />
              Speaker
            </TableCell>
            <TableCell>Symposium</TableCell>
            <TableCell>Onsite</TableCell>
            <TableCell>Online real-time</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Retirement Lecture</TableCell>
            <TableCell>Onsite</TableCell>
            <TableCell>Online real-time</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Industrial Session</TableCell>
            <TableCell>Onsite</TableCell>
            <TableCell>Online real-time</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Free Paper</TableCell>
            <TableCell>Onsite</TableCell>
            <TableCell>Online real-time</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderTable(mapObj, tblTitle) {
    return (
      <Table>
        {tblTitle && tblTitle}
        <TableBody className={this.props.classes.styledTd}>
          {Object.entries(mapObj).map((data, idx) => (
            <TableRow key={`table-row-${idx}`}>
              <TableCell
                width="30%"
                align="center"
                style={{ fontWeight: 'bold', borderRight: '1px solid rgba(224, 224, 224, 1)', whiteSpace: 'pre-line' }}
              >
                {data[0]}
              </TableCell>
              <TableCell width="70%" style={{ padding: this.props.theme.spacing(0, 3) }}>
                {data[1]}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes, theme } = this.props;

    const spacing = (heightNum) => {
      return <div style={{ height: `${heightNum ? heightNum : 20}px` }} />;
    };

    return (
      <>
        <Grid item xs={8} style={{ padding: theme.spacing(5, 0, 2) }}>
          <SubTitle>
            Presentation Guidelines for Invited Speakers / Abstract Presenter(Oral Presentation)
            {/* Guidelines for Invited / Oral Presentation */}
          </SubTitle>
          <Typography className={classes.content}>
            The conference will be held in ONSITE. We would like to invite you to give “ONSITE” lectures and presentations at the conference
            venue.
            <br /> Please read the guidelines below carefully and contact us if you have any questions.
            {/* The conference will be streamed live on PRS KOREA 2022 virtual platform.
            <br />
            Here are a few tips to make sure your presentation is successful. Please read carefully and contact us if you have any
            questions. */}
          </Typography>
        </Grid>

        <Grid item xs={8} className={`${classes.topSpacing}`}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  width="30%"
                  align="center"
                  style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}
                  rowSpan={4}
                >
                  Basic Rules
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Symposium Presentation Time:&nbsp;
                  <span style={{ color: 'red', fontWeight: 'bold' }}>12~15 min. (max) + 12~15 min. Q&A</span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Oral Presentation Time:&nbsp;
                  <span style={{ color: 'red', fontWeight: 'bold' }}>
                    5min. (max) &nbsp;<span style={{ color: '#000000' }}>+</span>&nbsp; 1 min. Q&A
                  </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Official Language: &nbsp;<span style={{ color: 'red', fontWeight: 'bold' }}>English</span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Presentation Slide Ratio: &nbsp;<span style={{ color: 'red', fontWeight: 'bold' }}>16:9</span> Screen format.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  PPT Template File
                  <br />
                  (Oral Presenter Only)
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  * Template Download
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ textTransform: 'none', fontWeight: 'bold', marginLeft: 10 }}
                    onClick={() => {
                      window.open(
                        `https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/paper/PRS%2BKOREA%2B2022_Oral%2BPresentation_PPT_Template.pptx`,
                        '_blank',
                      );
                    }}
                  >
                    Click
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  width="30%"
                  align="center"
                  style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}
                  rowSpan={5}
                >
                  Visual Equipment
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Each session room is equipped with the following equipment.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  - A monitor, microphone, mouse and smart pointer and timer will be provided on the podium for speakers.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  - There is no keyboard on the podium.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  - The Slide Note function (Presenter View mode) will be provided by default.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  - We recommend that you <span style={{ color: 'red', fontWeight: 'bold' }}>DO NOT</span> use your own laptop computer
                  (Apple Macintosh) for your presentation to avoid problems with computer-projector compatibility.
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        <Grid item xs={8} style={{ padding: theme.spacing(5, 0, 2) }}>
          <SubTitle>For Invited Speakers</SubTitle>
          <div style={{ color: '#555' }}>
            <ul className={classes.orderedList}>
              <li>
                It is encouraged your registration to be completed by <b style={{ color: 'red' }}>October 31(Mon)(23:59 KST), 2022.</b>{' '}
                <br />
                Your abstract will be automatically withdrawn if you do not complete your registration for PRS KOREA 2022.
              </li>
              <li>
                Please strive to be lecture for the entire session and be seated in the area designated for the lectures at the front of the
                room – the lectures will move very quickly.
              </li>
              <li>All speakers should bring their USB stick to upload your presentation file in the Preview Room.</li>
              <li>Files should be uploaded to the local PCs in the preview room during the breaks between the sessions, or earlier.</li>
              {/* <li>Due to time limitations, please note that no personal computer will be allowed for presentations.</li> */}
              <li>
                To use personal computer for presentation <span style={{ color: 'red', fontWeight: 'bold' }}>will not be allowed. </span>
              </li>
              <li>
                Speakers and presenters should arrive in the session room at least 15 minutes before the start of their sessions to report
                to the session Moderator(s).
              </li>
              <li>Please prepare a laptop adapter by yourself if you use own your laptop.</li>
            </ul>
          </div>
        </Grid>

        <Grid item xs={8} style={{ padding: theme.spacing(5, 0, 2) }}>
          <SubTitle>For Abstract Presenters</SubTitle>
          <div style={{ color: '#555' }}>
            <ul className={classes.orderedList}>
              <li>
                It is encouraged your registration to be completed by <b style={{ color: 'red' }}>October 31(Mon)(23:59 KST), 2022.</b>{' '}
                <br />
                Your abstract will be automatically withdrawn if you do not complete your registration for PRS KOREA 2022.
              </li>
              <li>
                Presentation will be no longer than &nbsp;<span style={{ color: 'red', fontWeight: 'bold' }}>6 minutes</span> in total. (5
                minutes of presentation and 1 minutes of Q&A)
              </li>
              <li>
                Please strive to be present for the entire session and be seated in the area designated for the presenters at the front of
                the room – the presentations will move very quickly.
              </li>
              <li>All presenters should bring their USB stick to upload your presentation file in the Preview Room.</li>
              <li>Files should be uploaded to the local PCs in the preview room during the breaks between the sessions, or earlier.</li>
              {/* <li>Due to time limitations, please note that no personal computer will be allowed for presentations.</li> */}
              <li>
                To use personal computer for presentation <span style={{ color: 'red', fontWeight: 'bold' }}>will not be allowed. </span>
                {/* Please note that personal computer <span style={{ color: 'red', fontWeight: 'bold' }}>will not</span> be allowed for
                presentation basically. */}
              </li>
              <li>
                Speakers and presenters should arrive in the session room at least 15 minutes before the start of their sessions to report
                to the session Moderator(s).
              </li>
              <li>Please prepare a laptop adapter by yourself if you use own your laptop.</li>
            </ul>
          </div>
        </Grid>

        <Grid item xs={8} style={{ padding: theme.spacing(5, 0, 2) }}>
          <SubTitle>File Submission</SubTitle>
          <div style={{ color: '#555' }}>
            <ul className={classes.orderedList} style={{ marginBottom: 0 }}>
              <li>
                Please submit your presentation file at the preview room at least &nbsp;
                <span style={{ color: 'red', fontWeight: 'bold' }}>1 hour</span> prior to your scheduled session to ensure the files
                function correctly in the given environment.
              </li>
              <li>
                Presentation slides should be prepared as an MS PowerPoint file in 2010 or 2013 versions. If you have any other types of
                presentation files, please inform our staff in the Preview Room in advance.
              </li>
            </ul>
            <span style={{ fontSize: '1.2em', marginBottom: 14 }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>*</b>&nbsp;&nbsp;As for the aspect of your presentation file (slides), a ratio of&nbsp;
              <span style={{ color: 'red', fontWeight: 'bold' }}>16:9 screen</span> format is recommended.
            </span>
          </div>
        </Grid>

        <Grid item xs={8} className={`${classes.topSpacing}`}>
          <SubTitle>Preview Room Operating Hours</SubTitle>
          {spacing(10)}
          <Table>
            <TableBody className={this.props.classes.styledTh}>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  Place
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Tulip Room (5F, Grand Intercontinental Seoul Parnas)
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  Date & Time
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  November 11(Fri) ~ 13(Sun), 07:30~18:00
                  {/* November 11(Fri)~12(Sat), 07:30~17:30
                  <br /> November 13(Sun), 07:30~18:00 */}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Typography className={classes.content}>
            <br />
            * If your file contains video or sound, please inform our staff and check the system in advance.
            <br /> * If you wish to present with your own laptop (IBM or Mac), you are required to test it at the Preview Room at
            least&nbsp;
            <b style={{ color: 'red' }}>1 hour</b> prior to your scheduled session.
          </Typography>
        </Grid>
        {/* <Grid item xs={8} style={{ padding: theme.spacing(5, 0, 2) }}>
          <SubTitle>Presentation Type & Method</SubTitle>
          <Typography className={classes.content}>{this.renderTypeInfoTable()}</Typography>
        </Grid> */}

        {/* <Grid item xs={8} className={`${classes.topSpacing}`}>
          <SubTitle>Presentation Time</SubTitle>
          <Table>
            <TableHead className={this.props.classes.styledTh}>
              <TableRow>
                <TableCell>Session Type</TableCell>
                <TableCell>Allocated Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={this.props.classes.styledTd}>
              {Object.entries(PRESENTATION_TIME).map((data, idx) => (
                <TableRow key={`table-row-${idx}`}>
                  <TableCell width="40%" align="center" style={{ borderRight: '1px solid rgba(224, 224, 224, 1)', whiteSpace: 'pre-line' }}>
                    {data[0]}
                  </TableCell>
                  <TableCell width="60%" align="center" style={{ padding: this.props.theme.spacing(0, 3) }}>
                    {data[1]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid> */}

        {/* <Grid item xs={8} className={`${classes.topSpacing}`}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SubTitle>For Onsite Presentation Speakers</SubTitle>
            <Button
              onClick={() => this.setState({ isShowOnsiteSpeakersInfo: !this.state.isShowOnsiteSpeakersInfo })}
              variant="contained"
              color="primary"
              size="small"
              disableElevation
              style={{ marginLeft: '1em' }}
            >
              {this.state.isShowOnsiteSpeakersInfo ? 'hide' : 'more'}
            </Button>
          </div>
          {this.state.isShowOnsiteSpeakersInfo && (
            <>
              <Typography className={classes.body}>Presentation File Format</Typography>
              {this.renderTable(
                FILE_FORMAT_DATA,
                <TableHead className={this.props.classes.styledTh}>
                  <TableRow>
                    <TableCell>Format</TableCell>
                    <TableCell>MS-PowerPoint (MS Office 2013, 2016, 2019~)</TableCell>
                  </TableRow>
                </TableHead>,
              )}
              {spacing()}
              <Typography className={classes.body}>Submitting the Presentation File</Typography>
              <TypoSub className={classes.typosub}>1. Pre-Submission</TypoSub>
              {this.renderTable(
                ONSITE_PRE_SUBMISSION_DATA,
                <TableHead className={this.props.classes.styledTh}>
                  <TableRow>
                    <TableCell colSpan={2}>Invited Lectures & Oral Presentation</TableCell>
                  </TableRow>
                </TableHead>,
              )}
              {spacing(10)}
              <TypoSub className={classes.typosub}>2. Onsite Preview & Final Submission</TypoSub>
              <div>
                Please visit <span style={{ color: '#3C67BC', fontWeight: 'bold' }}>the Preview Room at least 2 hours before</span> your
                scheduled presentation and bring your presentation files on a USB memory stick.
                <br />* Presenters are requested to check their presentation files to ensure they work correctly in our system.
              </div>
              {spacing(10)}
              <TypoSub className={classes.typosub}>3. Preview Room Operating Hours</TypoSub>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Date</TableCell>
                    <TableCell>November 11(Fri) – 13(Sun)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Time</TableCell>
                    <TableCell rowSpan={1} style={{ textAlign: 'center' }}>
                      06:30~18:00
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Place</TableCell>
                    <TableCell rowSpan={1} style={{ textAlign: 'center' }}>
                      Wisteria Room(2F)
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              {spacing()}
              <Typography className={classes.body}>Equipment</Typography>
              <div className={classes.indentText}>
                - Session rooms will be equipped with a computer and microphone.
                <br />
                - The podium will be equipped with a monitor, microphone, mouse.
                <br />
                - We DO NOT recommend using your own laptop computer for your presentation to avoid problems with computer-projector
                compatibility.
                <br />
                <b>
                  **Apple Macintosh / Apple Keynote / Personal Laptop Users: Please visit the onsite preview room and bring your Mini
                  Display Port-VGA Adapter.
                </b>
              </div>
              {spacing()}
              <Typography className={classes.body}>Before your Presentation</Typography>
              <div className={classes.indentText}>
                - Please be sure to keep to the allocated presentation time in consideration of the next speaker.
                <br />
                - Arrive at your session room at least 10 minutes before the session begins.
                <br />- You will be responsible for controlling/advancing your presentation slides.
              </div>
            </>
          )}
        </Grid> */}

        {/* <Grid item xs={8} className={`${classes.topSpacing}`}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SubTitle>For Pre Recorded Presentation Speakers</SubTitle>
            <Button
              onClick={() => this.setState({ isShowPreRecordedSpeakersInfo: !this.state.isShowPreRecordedSpeakersInfo })}
              variant="contained"
              color="primary"
              size="small"
              disableElevation
              style={{ marginLeft: '1em' }}
            >
              {this.state.isShowPreRecordedSpeakersInfo ? 'hide' : 'more'}
            </Button>
          </div>
          {this.state.isShowPreRecordedSpeakersInfo && (
            <>
              <Typography className={classes.body}>Presentation File Format</Typography>
              {this.renderTable(
                FILE_FORMAT_DATA,
                <TableHead className={this.props.classes.styledTh}>
                  <TableRow>
                    <TableCell>Format</TableCell>
                    <TableCell>MS-PowerPoint (MS Office 2013, 2016, 2019~)</TableCell>
                  </TableRow>
                </TableHead>,
              )}
              <Grid item xs={12} className={`${classes.topSpacing}`}>
                <TypoTitle>How to Record and Submit Your File</TypoTitle>
                <p className={classes.content} style={{ fontSize: '1.1em', lineHeight: '2em' }}>
                  We would kindly ask you to use <span style={{ color: '#3C67BC', fontWeight: 'bold' }}>'MS Powerpoint'</span> for recording
                  your presentation:
                </p>
                <div style={{ textAlign: 'center' }}>
                  <Button onClick={() => this.guideLinesDownload('eng')} variant="contained" color="secondary" disableElevation>
                    Recording Guidelines (ENG)
                  </Button>
                  <Button
                    onClick={() => this.guideLinesDownload('kor')}
                    variant="contained"
                    color="secondary"
                    disableElevation
                    style={{ marginLeft: '20px' }}
                  >
                    Recording Guidelines (KOR)
                  </Button>
                </div>
              </Grid>
              <Grid item xs={12} className={`${classes.topSpacing}`}>
                <TypoTitle>1. How to upload</TypoTitle>
                <Table>
                  <TableHead className={this.props.classes.styledTh}>
                    <TableRow>
                      <TableCell colSpan={3}>Invited Lectures & Oral Presentation</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Invited</TableCell>
                      <TableCell style={{ textAlign: 'center', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>mp4</TableCell>
                      <TableCell>
                        <span className={classes.redBold}>October 22(Fri), 2022</span>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Oral Presentation</TableCell>
                      <TableCell style={{ textAlign: 'center', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>mp4</TableCell>
                      <TableCell>
                        <span className={classes.redBold}>October 29(Fri), 2022</span>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                {spacing()}
                {this.renderTable(
                  HOW_TO_UPLOAD,
                  <TableHead className={this.props.classes.styledTh}>
                    <TableRow>
                      <TableCell colSpan={2}>Invited Lectures & Oral Presentation</TableCell>
                    </TableRow>
                  </TableHead>,
                )}
              </Grid>
            </>
          )}
        </Grid> */}

        {/* <Grid item xs={8} className={`${classes.topSpacing}`}>
          <div style={{ backgroundColor: '#eee', padding: this.props.theme.spacing(1, 2) }}>
            <Typography className={classes.body} style={{ fontWeight: 'bold' }}>
              For inquiries: PRS KOREA 2022 Secretariat
            </Typography>
            <p className={classes.content}>
              If you have any difficulties with submitting your file, please contact the PRS KOREA 2022 Secretariat.
              <br />
              E-mail: <a href={'mailto:secretariat.kprs@innon.co.kr'}>secretariat.kprs@innon.co.kr</a>
              <br />
              T. +82-2-6411-7380
            </p>
          </div>
        </Grid> */}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PresentationOral);
